export class DeactivateGcpFolderResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpFolder",
            "baseName": "gcpFolder",
            "type": "GcpOrganization",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DeactivateGcpFolderResponse.attributeTypeMap;
    }
    constructor() {
    }
}
